export class EstimateFunction {
  constructor(func_class_id?: string, description?: string) {
    this.func_class_id = func_class_id;
    this.description = description;
  }

  func_class_id: string;
  description: string;
}
